import React from 'react';
import { useOutletContext } from 'react-router-dom';

import { Details } from '~/components';
import { Inner } from '~/styles';

import { CardDisputeProps } from './CardDispute';

export const PageCardDisputeApiResponse: React.FC = () => {
  const { cardDispute } = useOutletContext<CardDisputeProps>();

  if (!cardDispute) {
    return null;
  }

  return (
    <Inner pt={24} px={0} pb={0}>
      <Details
        label="API Response"
        formattedData={cardDispute as unknown as Record<string, unknown>}
        rawData={cardDispute as unknown as Record<string, unknown>}
      />
    </Inner>
  );
};
